// Use translation files
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enNs from './locales/en/translation.json';

export const defaultNS = 'translation';

i18next.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'en',
  defaultNS,
  resources: {
    en: {
      ns: enNs,
    },
  },
});

export default i18next;
